import ActionTypes from './actionTypes';

import { createAction } from '@/utils/actionCreator';

export const login = createAction(ActionTypes.LOGIN, 'email', 'password');

export const reset = createAction(ActionTypes.RESET);
